/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:29a3e2b4-9b8c-4847-99c0-f35c1cbda01b",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_HFDGJyeNP",
    "aws_user_pools_web_client_id": "6b82h1lin98uv89gilo9gk1kd1",
    "oauth": {}
};


export default awsmobile;
